import React from 'react';
import { Tooltip, tooltipClasses, styled } from '@mui/material';

export function CxTooltip({ title, children, ...props }) {

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: theme.palette.common.silver,
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.silver,
            fontSize: 14
        },
    }));

    return (
        <BootstrapTooltip title={title} {...props}>
            {children}
        </BootstrapTooltip>
    );
}
